import { useState, useRef, useCallback, useEffect } from 'react';

var EnumSystemTheme;

(function (EnumSystemTheme) {
  EnumSystemTheme["light"] = "light";
  EnumSystemTheme["dark"] = "dark";
})(EnumSystemTheme || (EnumSystemTheme = {}));

var useSystemTheme = function useSystemTheme() {
  var _window$document, _window$document$body, _window$document$body2;

  var initialTheme = typeof window !== 'undefined' && ((_window$document = window.document) == null ? void 0 : (_window$document$body = _window$document.body) == null ? void 0 : (_window$document$body2 = _window$document$body.dataset) == null ? void 0 : _window$document$body2.theme);

  var _useState = useState(initialTheme || undefined),
      systemTheme = _useState[0],
      setSystemTheme = _useState[1];

  var darkThemeMatchMedia = useRef();
  var handleChangeTheme = useCallback(function (event) {
    setSystemTheme(event.matches ? EnumSystemTheme.dark : EnumSystemTheme.light);
  }, []);
  useEffect(function () {
    var _darkThemeMatchMedia$;

    darkThemeMatchMedia.current = window.matchMedia('(prefers-color-scheme: dark)');
    var theme = (_darkThemeMatchMedia$ = darkThemeMatchMedia.current) != null && _darkThemeMatchMedia$.matches ? EnumSystemTheme.dark : EnumSystemTheme.light;
    setSystemTheme(theme);
  }, []);
  useEffect(function () {
    var _darkThemeMatchMedia$2;

    if ((_darkThemeMatchMedia$2 = darkThemeMatchMedia.current) != null && _darkThemeMatchMedia$2.addEventListener) {
      var _darkThemeMatchMedia$3;

      (_darkThemeMatchMedia$3 = darkThemeMatchMedia.current) == null ? void 0 : _darkThemeMatchMedia$3.addEventListener('change', handleChangeTheme, false);
    } else {
      var _darkThemeMatchMedia$4;

      (_darkThemeMatchMedia$4 = darkThemeMatchMedia.current) == null ? void 0 : _darkThemeMatchMedia$4.addListener == null ? void 0 : _darkThemeMatchMedia$4.addListener(handleChangeTheme);
    }

    return function () {
      var _darkThemeMatchMedia$5;

      if ((_darkThemeMatchMedia$5 = darkThemeMatchMedia.current) != null && _darkThemeMatchMedia$5.removeEventListener) {
        var _darkThemeMatchMedia$6;

        (_darkThemeMatchMedia$6 = darkThemeMatchMedia.current) == null ? void 0 : _darkThemeMatchMedia$6.removeEventListener('change', handleChangeTheme);
      } else {
        var _darkThemeMatchMedia$7;

        (_darkThemeMatchMedia$7 = darkThemeMatchMedia.current) == null ? void 0 : _darkThemeMatchMedia$7.removeListener == null ? void 0 : _darkThemeMatchMedia$7.removeListener(handleChangeTheme);
      }
    };
  }, [handleChangeTheme]);
  return {
    systemTheme: systemTheme
  };
};

export { EnumSystemTheme, useSystemTheme };
